import { render, staticRenderFns } from "./CommentTextarea.vue?vue&type=template&id=0231a9ee&scoped=true&"
import script from "./CommentTextarea.vue?vue&type=script&lang=js&"
export * from "./CommentTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CommentTextarea.vue?vue&type=style&index=0&id=0231a9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231a9ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0231a9ee')) {
      api.createRecord('0231a9ee', component.options)
    } else {
      api.reload('0231a9ee', component.options)
    }
    module.hot.accept("./CommentTextarea.vue?vue&type=template&id=0231a9ee&scoped=true&", function () {
      api.rerender('0231a9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/CommentTextarea.vue"
export default component.exports